import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { MainLayout } from '../../components/layouts/MainLayout';
import { SimpleSkeleton } from '../../components/atoms/SimpleSkeleton';
import Header from './parts/FinanceAdsHeader';
import FinanceAdsIframe from './parts/FinanceAdsIframe';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { Container } from '../../uikit/grid';
var mapStateToProps = function (state) { return ({
    placementId: initialDataSlice.selectors.getPlacementId(state),
    loanAmount: initialDataSlice.selectors.getAmount(state),
}); };
export function RawFinanceAdsPage(props) {
    var placementId = props.placementId, loanAmount = props.loanAmount;
    var _a = useState(false), isLoaded = _a[0], setIsLoaded = _a[1];
    var handleIframeLoaded = useCallback(function (isLoaded) {
        setIsLoaded(isLoaded);
    }, []);
    return (React.createElement(MainLayout, { flatHeader: true },
        React.createElement(Header, null),
        React.createElement(Container, null,
            React.createElement(SimpleSkeleton, { isLoading: !isLoaded },
                React.createElement(FinanceAdsIframe, { onLoaded: handleIframeLoaded, placementId: placementId, loanAmount: loanAmount })))));
}
export var FinanceAdsPage = connect(mapStateToProps)(RawFinanceAdsPage);
